import React, { ReactElement, ReactNode } from 'react';
import DevicesProviderContext from 'shared/providers/devices/contexts/devices-provider-context';
import { DevicesState, useDevicesState } from 'shared/providers/devices/hooks/devices-state';

const DevicesContext = React.createContext<DevicesState>({} as never);

type Props = {
  children: ReactNode;
};

export const DevicesProvider = (props: Readonly<Props>): ReactElement => {
  return <DevicesProviderContext value={useDevicesState()}>{props.children}</DevicesProviderContext>;
};

export const useDevicesContextProvider = (): DevicesState => React.useContext<DevicesState>(DevicesContext);
